<template>
  <app-layout :state="state">
    <app-header>
      <icon-link
        :href="route('home')"
        icon="arrow-thin-left-circle"
        class="icons-secondary"
      >
        Back to dashboard
      </icon-link>
      <h1 class="mb-0 leading-tight">
        All funding pots
      </h1>
    </app-header>
    <div class="container">
      <ul class="list-reset relative">
        <li
          v-for="fundingPot in fundingPots"
          :key="fundingPot.id"
          class="card is-borderless py-6 mb-6 flex items-baseline"
        >
          <div class="mx-6 w-1/3">
            <h3 class="text-base">
              {{ fundingPot.name }}
            </h3>
          </div>
          <div class="mx-6 w-1/5">
            <p>£{{ fundingPot.amount.toLocaleString("en-GB") }}</p>
          </div>
          <div class="mx-6">
            <icon
              icon="trophy"
              class="w-5 h-5 icons-primary align-text-bottom"
            />
            {{ fundingPot.competitions.length }}
          </div>
          <card-actions class="z-0 ml-auto mr-6 text-primary-500">
            <ul class="list-reset text-sm text-center">
              <li
                v-for="action in actions"
                :key="action.key"
                class="p-2 border-b"
              >
                <a
                  class="block no-underline hover:text-primary-800 text-black"
                  :href="route(action.key, fundingPot.id)"
                >
                  {{ action.label }}
                </a>
              </li>
            </ul>
          </card-actions>
        </li>
      </ul>
    </div>
  </app-layout>
</template>

<script>
export default {
  name: "FundingIndex",
  computed: {
    fundingPots() {
      return this.state.funding_pots;
    },
    actions() {
      return [
        {
          label: "Settings",
          key: "funding.show"
        },
        {
          label: "Competitions",
          key: "funding.competitions.index"
        },
        {
          label: "Applications",
          key: "funding.applications.index"
        },
        {
          label: "Grading",
          key: "funding.grading.index"
        },
        {
          label: "Projects",
          key: "funding.projects.index"
        }
      ];
    }
  }
};
</script>
